
import { defineComponent, onMounted, reactive, Ref, ref } from "vue";
import $API from "@/services";

import { RequestKindTypes } from "@/models/request";
import RequestView from "@/components/common/Request/RequestView.vue";
import router from "@/router";
import OrderResultView from "@/components/mypage/OrderResultView.vue";
import CancelConfirm from "@/components/common/Confirm/CancelConfirm";

export default defineComponent({
  name: "Order Result",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const state = reactive({
      RequestKey: "",
      paymentKey: props.id,
      isLoading: true,
      orderNumber: "",
    });

    const cancel$: Ref<CancelConfirm | null> = ref(null);

    const updateCardInfo = (orderNumber: string) => {
      state.orderNumber = orderNumber;
    };

    const CancelRequest = (requestKey: number) => {
      cancel$.value?.cancelConfirm(requestKey);
    };

    const getRequestKey = async () => {
      try {
        state.RequestKey = await $API.PaymentsService.getRequestKey(props.id);
      } catch(ex) {
        console.warn(ex);
      }
     
      state.isLoading = false;
    };

    const CancelAccept = () => router.go(0);

    onMounted(() => {
      getRequestKey();
    });

    return {
      state,
      RequestKindTypes,
      CancelAccept,
      CancelRequest,
      updateCardInfo,
      cancel$,
    };
  },
  components: {
    RequestView,
    OrderResultView,
    CancelConfirm,
  },
});
